import { inject, Injectable } from '@angular/core';
import { AppTextService } from '@fi-app/shared/app-text';
import { ExtendSharingService } from '@fi-app/components/extend-sharing/extend-sharing.service';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { ObjectTypes } from '@fi-shared/types';

@Injectable()
export class FiBusinessAreaListHelperService {
    private appTextService = inject(AppTextService);
    extendSharingService = inject(ExtendSharingService);

    getItemsListActions(deleteSelectedBusinessAreasFn: () => void): IItemsListAction2[] {
        return [
            {
                title: this.appTextService.get('common.delete'),
                onClick: deleteSelectedBusinessAreasFn
            },
        ];
    }

    getListItemActions(): IItemsListAction2[] {
        if (!this.extendSharingService.hasAccessToExtendSharing()) {
            return [];
        }
        return [
            {
                title: this.appTextService.get('sharing.extend_sharing_to'),
                onClick: (item) => {
                    this.extendSharingService.openExtendedSharing(item.Id, ObjectTypes.BusinessArea);
                },
            },
        ];
    }
}
